module.exports = __webpack_public_path__ + "img/icon4-1(1).4e040699.png";